import { Node, Transforms, Editor, Element, Path } from 'slate';
import { CustomEditor, LinkElement } from 'slate/types/slate';

export interface LinkRef {
  id?: string;
  bookmarkId?: string;
  path: Path;
  content: string;
}

export const insertLink = async (editor: CustomEditor, linkId: string, bookmarkId: string, _documentSuperId: string, _sectionId: string) => {
  const link: LinkElement = { type: 'link', id: linkId, bookmarkId: bookmarkId, children: [] };
  Transforms.wrapNodes(editor, link, { split: true });
};

export const updateLinkBookmark = async (editor: CustomEditor, linkId: string, bookmarkId: string) => {
  Transforms.setNodes(editor, { id: linkId, bookmarkId }, { match: (n) => Element.isElement(n) && n.type === 'link' });
};

export const getAllLinks = (editor: CustomEditor): LinkRef[] => {
  const links: LinkRef[] = [];

  for (const [node, path] of Node.nodes(editor, { reverse: false })) {
    if (Element.isElement(node) && node.type === 'link') {
      links.push({
        id: node.id,
        bookmarkId: node.bookmarkId,
        path,
        content: Node.string(node),
      });
    }
  }

  return links;
};

export const removeLink = async (id: string, editor: CustomEditor) => {
  const [nodeEntry] = Editor.nodes(editor, {
    match: (node) => Element.isElement(node) && node.type === 'link' && node.id === id,
    at: [],
  });
  if (!nodeEntry) return;
  Transforms.unwrapNodes(editor, { at: nodeEntry[1] });
};

export const getLinkById = (editor: CustomEditor, linkId: string): { all: LinkRef[]; found: LinkRef | undefined } => {
  const links: LinkRef[] = [];

  for (const [node, path] of Node.nodes(editor, { reverse: false })) {
    if (Element.isElement(node) && node.type === 'link') {
      links.push({
        id: node.id,
        path,
        content: Node.string(node),
      });
    }
  }
  return { all: links, found: links.find((bm) => bm.id === linkId) };
};
